// @ts-check
import _ from 'lodash';

const numDecimals = 2;

/**
 * @param {number|string} value
 * @param {string} unit
 * @return {string}
 */
export const formatValueWithUnit = (value, unit, undefinedValueString = '-') => {
  return `${value ?? undefinedValueString} ${unit}`;
};

/**
 * @param {string} value
 * @return {number|string}
 */
export const limitDecimals = (value, undefinedValueString = '-') => {
  if (value == null) {
    return undefinedValueString;
  }
  const numberValue = _.toNumber(value);

  if (_.isNumber(numberValue) && !_.isNaN(numberValue)) {
    if (_.isInteger(numberValue)) {
      return value;
    }

    return _.round(numberValue, numDecimals);
  }

  return value;
};
